import { render, staticRenderFns } from "./OverviewHeader.vue?vue&type=template&id=05b39116&"
import script from "./OverviewHeader.vue?vue&type=script&lang=js&"
export * from "./OverviewHeader.vue?vue&type=script&lang=js&"
import style0 from "./OverviewHeader.vue?vue&type=style&index=0&id=05b39116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports